// Shared by the backend OCR proxies (Cloud Vision and the AI-assisted
// fallback) - both need photos downscaled and re-encoded as JPEG to stay
// well under API Gateway's payload limit and keep uploads fast.
export const MAX_DIMENSION = 1800;
export const JPEG_QUALITY = 0.85;

export async function resizeAndEncodeAsJpeg(source: File | Blob): Promise<string> {
    const objectUrl = URL.createObjectURL(source);
    try {
        const image = await new Promise<HTMLImageElement>((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error("Couldn't load the image"));
            img.src = objectUrl;
        });

        const scale = Math.min(1, MAX_DIMENSION / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(image.naturalWidth * scale);
        canvas.height = Math.round(image.naturalHeight * scale);
        const ctx = canvas.getContext("2d");
        if (!ctx) throw new Error("Canvas 2D context is unavailable");
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        const dataUrl = canvas.toDataURL("image/jpeg", JPEG_QUALITY);
        return dataUrl.slice(dataUrl.indexOf(",") + 1);
    } finally {
        URL.revokeObjectURL(objectUrl);
    }
}
